var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.34 51.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#fff;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-299.96 -2.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.77,28.52,396.68,39.61l2.45,2.45a3.25,3.25,0,0,0,4.69,0l13.53-13.54Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -121.46,
    y1: 762.91,
    x2: -120.46,
    y2: 762.91,
    gradientTransform: "matrix(0, 6.79, 6.79, 0, -4771.07, 855.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3f9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#439745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4da949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#50af4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50af4a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-299.96 -2.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.13,14.29l-2.45,2.45,11.09,11.08h9.58L403.82,14.29a3.83,3.83,0,0,0-2.43-1,3.14,3.14,0,0,0-2.26,1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -76.84,
    y1: 718.36,
    x2: -75.84,
    y2: 718.36,
    gradientTransform: "translate(924.03 -4855.18) scale(6.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#469d46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4daa49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#50af4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50af4a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-299.96 -2.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.6,28.52,396.47,39.4l4.79-4.79-6.08-6.09Zm0-.7h9.58l6.09-6.09-4.79-4.79Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -139.87,
    y1: 718.67,
    x2: -138.87,
    y2: 718.67,
    gradientTransform: "matrix(-15.89, 0, 0, 15.89, -1818.33, -11388.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c7c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646463"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "valmet_logo_nega") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 394.1,
    y: 23.54,
    width: 25.84,
    height: 25.84,
    transform: "translate(-206.53 295.57) rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 394.56,
    y: 8.08,
    width: 24.92,
    height: 24.92,
    transform: "translate(-195.26 290.91) rotate(-45)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.77,27.87h-5c.25-1.81.81-2.4,2.59-2.4s2.32.42,2.37,2.4m-2.67-5.64c-4.1,0-6.73,1.71-6.73,7.45s3,7.62,7,7.62a18.55,18.55,0,0,0,5.16-.78l-.64-3.27a19.39,19.39,0,0,1-4,.48c-2.06,0-3.09-.42-3.15-2.71h8.73c.39-7.34-1.67-8.79-6.41-8.79",
    transform: "translate(-299.96 -2.91)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.87,30.89c-.82-3.12-3-9.88-4.25-13.29a1.23,1.23,0,0,0-1-.83H300V17s.91.12,1.56,2.11c1.34,4.06,4.51,14,5.59,17.83h5.26c1.87-4.55,5.28-15.6,6.62-20.14h-4.73c-1,3.28-3.25,10.86-4.39,14.12",
    transform: "translate(-299.96 -2.91)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.69,16.76h-4.3v16.1c0,5.07,4.95,4.32,4.95,4.32a11.38,11.38,0,0,1-.65-4.43Z",
    transform: "translate(-299.96 -2.91)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.6,26.31a6.81,6.81,0,0,1,1.87-.25c1.95,0,2.37.69,2.37,3.29v7.56h4.27V29a12.17,12.17,0,0,0-.28-2.7,10.45,10.45,0,0,1,2.15-.25c1.95,0,2.37.69,2.37,3.29v7.56h4.27V29c0-5.13-1.76-6.78-5.72-6.78a15.65,15.65,0,0,0-4.94.92,5.89,5.89,0,0,0-3.57-.92,22,22,0,0,0-7.09,1.29V36.91h4.3Z",
    transform: "translate(-299.96 -2.91)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M383,26.31V22.62h-4.46v-2.4a17.64,17.64,0,0,1,.29-3.46s-4.59.6-4.59,3.74v2.12H372v3.69h2.31v5.77c0,4.27,1.76,5.22,4.91,5.22a12.14,12.14,0,0,0,4.3-.73l-.7-3.29a7.06,7.06,0,0,1-2.29.39c-1.5,0-1.92-.58-1.92-2V26.31Z",
    transform: "translate(-299.96 -2.91)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325,33.73a7.24,7.24,0,0,1-2.38.39c-1.67,0-2-.25-2-1.7s.55-1.59,2.09-1.59A9.68,9.68,0,0,1,325,31Zm4.07,2.45V27.79c0-4.25-2-5.56-6.28-5.56a13.46,13.46,0,0,0-4.33.5l-1.22,3.64a16.54,16.54,0,0,1,4.52-.65c2.79,0,3.24.56,3.24,2.54a16.49,16.49,0,0,0-3.24-.36c-3.41,0-5.58.64-5.58,4.66,0,3.74,1.39,4.74,6.11,4.74a22.1,22.1,0,0,0,6.78-1.12",
    transform: "translate(-299.96 -2.91)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 379.95,
    y: 14.69,
    width: 26.96,
    height: 26.96,
    transform: "translate(-204.64 283.54) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValmet);
export default __webpack_public_path__ + "static/media/valmet.e4087d53e9e1842bae7679d77a8d3162.svg";
export { ForwardRef as ReactComponent };